import { h } from "preact";

import Icon from "./Icon.jsx";

export default function HeaderIcon(props) {
  return (
    <div class="mb-32">
      <Icon {...props} />
    </div>
  );
}
